export { Space } from "@mantine/core";
